module.exports = __webpack_public_path__ + "img/Upload Documents@3x.00ef76cd.png";